<i class="{{ iconClass }} icon icon-spinner icon-is-spinning "></i>
